import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { AppInitialize } from '../app-init.service';
import { ButtonType, ConfirmationModel, ConfirmationPopupComponent } from '../common-component/confirmation-popup/confirmation-popup.component';
import { CommonService } from '../common-services/common-functions.service';
import { AccessLevel, ConfirmationHeader } from '../common-services/enum.service';
import { IShortCutKeys } from '../common-services/interface.service';
import { ApiResponse, CommonFilter } from '../common-services/models.service';
import { NewConfirmationModel, ConfirmationTablePopupComponent } from '../common-component/confirmation-table-popup/confirmation-table-popup.component';// ~~~~~~~~~~~~~~~~ Tushar 2025-08-28 Gid.:#1303 
import { API_ENDPOINTS } from '../common-services/constants.service';

@Injectable()
export class SharedService {

  sharedMaster = {};
  tableConfiguration = {};
  reportConfiguration = {};
  notificationCnt: number = 0;
  // ddl = { 1: { api: 'state/ddlist', list: new Array<any>() } };
  shortCutKeyListner = new Subject<IShortCutKeys>();
  showLoader = new BehaviorSubject(false);
  autoSearchArray = {};
  masterUrl = {
    1: { 'List': API_ENDPOINTS.USERS_SEARCH, 'Save': API_ENDPOINTS.CREATE, 'Delete': API_ENDPOINTS.DELETE, 'Filter': API_ENDPOINTS.PAYMENT, 'isExists': '', 'byId': API_ENDPOINTS.USER }
  };

  searchProgress = false;
  printObject = null;
  formBtn = {
    actionAccess: AccessLevel.None
  };

  storeAssignment = {
    assignedStore: [],
    assignedState: [],
    assignedDistrict: []
  };

  stateDistrict = {
    stateList: [],
    districtList: [],
    /*---- start 02-03-2026 ID : 1324(zota/netcore/cpos/cpos_web_angular) Nidhi Bhosale */
    zoneList:[],
    storeCatergoryList:[],
    /*---- end 02-03-2026 ID : 1324(zota/netcore/cpos/cpos_web_angular) Nidhi Bhosale */
    totalStore: 0
  };

  pageRouteConfig = {
    59: { pageRoute: 'user/scheme/', retriveField: 'sM_Id' },
    60: { pageRoute: 'master/item/', retriveField: 'id' },
    61: { pageRoute: 'master/salt/', retriveField: 'salt_Id' },
    62: { pageRoute: 'master/otherbrand/', retriveField: 'obM_Id' },
    63: { pageRoute: 'master/welcomekit/', retriveField: 'wel_Id' },
    64: { pageRoute: 'master/documentlibrary/', retriveField: 'doc_Id' },
    89: { pageRoute: 'store/documentprocess/', retriveField: 'storeId' },
    90: { pageRoute: 'store/execution/', retriveField: 'storeId' },
    91: { pageRoute: 'user/employee/', retriveField: 'empId' },
    95: { pageRoute: 'user/adjustpoints/', retriveField: 'spid' },
    99: { pageRoute: 'user/schemetransaction/', retriveField: 'storeId' },
    103: { pageRoute: 'store/tabsequence/', retriveField: 'tab_Type' },
    106: { pageRoute: 'stockreturn/returnpolicy/', retriveField: 'id' },
    107: { pageRoute: 'batchrecall/recall/', retriveField: 'id' },
    111: { pageRoute: 'master/proportionateschememrp/', retriveField: 'id' },
    123: { pageRoute: 'user/schememasterdetails/', retriveField: 'schemeId' },
    131: { pageRoute: 'master/Notification/', retriveField: 'notification_Id' },
    138: { pageRoute: 'master/TermsAndConditions/', retriveField: 'termsAndConditions_Id' },
    143: { pageRoute: 'store/documentprocess/', retriveField: 'storeId', versionField: 'versionNo' },
    153: { pageRoute: 'store/execution/', retriveField: 'storeId', versionField: 'versionNo' },
    161: { pageRoute: 'master/Reason/', retriveField: 'reason_Id'}, //~~~~~~~~~~ Rahul 2024-05-07 GID: 792
    170: { pageRoute: 'master/pettyCashAllocation/', retriveField:'dsea_id' }, // Date: 03/10/2024  Developer: Pankaj Motwani  Git Id: 946
    177: { pageRoute: 'master/expenseincomecategory/', retriveField:'id'}, // Date: 13/02/2025 Developer: Nishita Roy  Git Id: 1107
    183: { pageRoute: 'master/Coupon/', retriveField: 'couponSlabId'},
    193: { pageRoute: 'master/ProductCategoryWiseExpiry/',retriveField:'expiryValidationID'}  /*  Nidhi Bhosale 2026-03-23 ID(zota/cpos/cpos_web_angular):2463(CPOS)  */
  };

  constructor(public dialog: MatDialog, private httpClient: HttpClient, private appInit: AppInitialize) { }
  public isEnableOrVisible(no): boolean {
    return (this.formBtn.actionAccess & no) > 0;
  }

  getConfirmatonConfig(header: ConfirmationHeader, message, _buttonType: ButtonType = ButtonType.YesNo, data: any = null) {
    return this.dialog.open(ConfirmationPopupComponent, {
      width: '400px',
      data: new ConfirmationModel(header, message, _buttonType, data),
      disableClose: true,
      closeOnNavigation: true
    });
  }

  getTableConfirmatonConfig(header: ConfirmationHeader, message, _buttonType: ButtonType = ButtonType.YesNo, data: any = null,_dataSource: any = null,_tableObject: any = null, _isExport:boolean = false) {
    debugger
    let objLW = CommonService.mainSectionLW;
    
    return this.dialog.open(ConfirmationTablePopupComponent, {
        maxWidth: objLW.width > 0 ? `${((objLW.width / 2) + 200)}px` : '600px',
        maxHeight: objLW.height > 0 ? `${(objLW.height - 400)}px` : '400px',
        data: new NewConfirmationModel(header, message, _buttonType, data, _dataSource, _tableObject, _isExport),
        disableClose: true,
        closeOnNavigation: true
      });

  }

  public get StateDistrict(): Observable<any> {
    if (this.stateDistrict.stateList.length === 0) {
      return this.StateDistrictByUser(0);
    } else {
      return Observable.of(CommonService.copyObject(this.stateDistrict));
    }
  }

  public StateDistrictByUser(userid = 0): Observable<any> {
    return this.customGetApi(API_ENDPOINTS.DEFAULT_STORE_DATA + userid).map((t: any) => {
      this.stateDistrict.stateList = t.states;
      this.stateDistrict.districtList = t.district;
      this.stateDistrict.totalStore = t.totalStore;
      /*---- start 02-03-2026 ID : 1324(zota/netcore/cpos/cpos_web_angular) Nidhi Bhosale */
      this.stateDistrict.storeCatergoryList=t.storeCategory;
      this.stateDistrict.zoneList=t.zone;
      /*---- end 02-03-2026 ID : 1324(zota/netcore/cpos/cpos_web_angular) Nidhi Bhosale */
      return CommonService.copyObject(this.stateDistrict);
    });
  }

  getTableConfiguration(page: any) {
    if (this.tableConfiguration[page] && this.tableConfiguration[page].length > 0) {
      return Observable.of({ data: this.tableConfiguration[page] });
    } else {
      return this.customGetApi(API_ENDPOINTS.TBL_CONFIG + page).map((t) => {
        this.tableConfiguration[page] = t.data;
        
        return t;
      }).catch(err => Observable.throw(err));
    }
  }

  getReportConfiguration(page: any) {
    if (this.reportConfiguration[page]) {
      return Observable.of({ data: this.reportConfiguration[page] });
    } else {
      return this.customGetApi(API_ENDPOINTS.REPORT_CONFIG + page).map((t) => {

        const filter = this.getSearchFilter(page);
        if (t && t.data && t.data.hasFromToDateField ) {
          const d = new Date();
          d.setDate(d.getDate() - (t.data.defDateDurationInDays > 0 ? t.data.defDateDurationInDays : 30));
          
          filter.filterArray.push({ key: t.data.hasFromToDateField + '_from', value: d });
          filter.filterArray.push({ key: t.data.hasFromToDateField + '_to', value: new Date() });
          
        }
        if(!isNullOrUndefined(t.data.lstFilterData) ){
          t.data.lstFilterData.forEach(element=>{
            filter.filterArray.push({key : element.defaultSearchField , value : element.defaultSearchValue})
          })
          
        }
        this.sharedMaster[page].searchFilter = filter;
        this.reportConfiguration[page] = t.data;
        return t;
      }).catch(err => Observable.throw(err));
    }
  }

  getSearchFilter(page: any, _pageSize = 0) {
    if (isNullOrUndefined(this.sharedMaster[page])) {
      this.sharedMaster[page] = new FilterObject(new CommonFilter(page, (_pageSize > 0 ? _pageSize : this.appInit.gridItemsPerPage)));
    }
    return this.sharedMaster[page].searchFilter;
    //let filter = new CommonFilter();
    //if (!isNullOrUndefined(this.sharedMaster[page])) {
    //    filter = this.sharedMaster[page].searchFilter;
    //} else {
    //    filter.pageNumber = 1;
    //    filter.pageSize = pageSize;
    //}
    //return filter;
  }

  // searchDropdownList(ddlFor, param: string = '') {
  //   return this.httpClient.get(this.ddl[ddlFor].api + param).map((t: ApiResponse) => t.data);
  // }

  //----~~~ 02-10-2024 #915 Nidhi 
  getReportfilter(page: any,filter) {      
    return    this.customGetApi(API_ENDPOINTS.REPORT_CONFIG + page).map((t) => {       
           if (t && t.data && t.data.hasFromToDateField ) {
           const d = new Date();          
           d.setDate(d.getDate() - (t.data.defDateDurationInDays > 0 ? t.data.defDateDurationInDays : 30));
           filter.filterArray.push({ key: t.data.hasFromToDateField + '_from', value: d });
           filter.filterArray.push({ key: t.data.hasFromToDateField + '_to', value: new Date() });
          }
         if(!isNullOrUndefined(t.data.lstFilterData) ){
           t.data.lstFilterData.forEach(element=>{
             filter.filterArray.push({key : element.defaultSearchField , value : element.defaultSearchValue})
            filter.searchField= element.defaultSearchField ;
            filter.searchValue=element.defaultSearchValue;
           })          
         }
       this.sharedMaster[page].searchFilter = filter;    
       return this.sharedMaster[page].searchFilter;
       }).catch(err => Observable.throw(err));      
   }
   
  filter(master: any, param1: any = null, queryParam: any = null): Observable<any> {
    if (!isNullOrUndefined(queryParam)) {
      return this.httpClient.post<ApiResponse>(this.masterUrl[master].Filter + queryParam, param1).map(t => t);
    } else {
      return this.httpClient.post<ApiResponse>(this.masterUrl[master].Filter, param1).map(t => t);
    }
  }

  getFilter(filter): Observable<any> {
    return this.httpClient.post<any[]>(API_ENDPOINTS.FILTER, filter).map(t => t);
  }

  getList(master: any, param1: any = ''): Observable<any> {
    return this.httpClient.get<any[]>(this.masterUrl[master].List + param1).map(t => t);
  }

  // customGetApi(api: string): Observable<ApiResponse> {
  //    
  //   this.showLoader.next(true);
  //   return this.httpClient.get<ApiResponse>(api).map((t) => {{
  //     this.showLoader.next(false);
  //   } 
  //     return t;
  //   }).catch((err: any) => {
  //      
  //     this.showLosssader.next(false);
  //     return Observable.throw(err)
  //   });
   
  // }

  customGetApi(api: string): Observable<ApiResponse> {
    return this.httpClient.get<ApiResponse>(api).map(t => t).catch(err => Observable.throw(err));
  }


  customPostApi(api: string, data: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(api, data).map(t => t).catch(err => Observable.throw(err));
  }
  

  // customPostApi(api: string, data: any): Observable<any> {
  //   this.showLoader.next(true);
  //   return this.httpClient.post(api, data,{ responseType: 'blob', observe: 'response' }).map((t) => {{
  //     this.showLoader.next(false);
  //   }

  //     return t;
  //   }).catch((err: any) => {
  //     return Observable.throw(err)
  //   });

  // }

  // customPostApi(api: string, data: any): Observable<ApiResponse> {
  //   this.showLoader.next(true);
  //   return this.httpClient.post<ApiResponse>(api, data).map((t) => {{
  //     this.showLoader.next(false);
  //   }
      
  //     return t;
  //   }).catch((err: any) => {
  //     return Observable.throw(err)
  //   });
    
  // }

  previewImage(url: string, filePath: string): Observable<any> {
    if (!isNullOrUndefined(filePath) && filePath !== '') {
      return this.httpClient.get(url + encodeURIComponent(filePath), { responseType: 'blob', observe: 'response' });
    } else {
      return Observable.of(null);
    }
  }

  previewReport(url: string, data: any): Observable<any> {
    return this.httpClient.post(url, data, { responseType: 'blob', observe: 'response' });
  }

  uploadFile(_file, dataParam: { id: string, storeCode: string, docType: number }, url = API_ENDPOINTS.UPLOAD) {
    if (_file) {
      let formData = new FormData();
      formData.append('profileImage', _file, _file.name);
      Object.keys(dataParam).forEach(key => {
        formData.append(key, dataParam[key]);
      });
      // formData.set('content', _file, _file.name);
      let RequestParams = new HttpParams();
      if (dataParam) {
        Object.keys(dataParam).forEach(function (key) {
          RequestParams = RequestParams.append(key, dataParam[key]);
        });
      }
      return this.httpClient.post<any>(url, formData, { params: RequestParams });
    }
  }

  uploadbase64File(dataParam: {FilePath : string , StoreId: number, DocumentMasterId: number, docType: number }, url = API_ENDPOINTS.UPLOAD_BASE64) {
    //if (_file) {
      // let formData = new FormData();
      // formData.set('content', _file, _file.name);
      // let RequestParams = new HttpParams();
      // if (dataParam) {
      //   Object.keys(dataParam).forEach(function (key) {
      //     RequestParams = RequestParams.append(key, dataParam[key]);
      //   });
      // }

      return this.httpClient.post<any>(url, dataParam);
    //}
  }

  autoCompleteFilter(val: any, value: any) {
    
    const searchval = val ? val : '';
    if (value && (!this.autoSearchArray[value] || this.autoSearchArray[value].length == 0)) {
      return this.customGetApi(API_ENDPOINTS.AUTO_SEARCH + value).map(t => {
        if (t.data) {
          
          const key = Object.keys(t.data[0])[0];
          this.autoSearchArray[value] = t.data.map(x => x[key]);
          return this.autoSearchArray[value].filter(option => option.toLowerCase().includes(searchval.toLowerCase()));
        } else {
          return [];
        }
      });
    } else {
      return Observable.of(((this.autoSearchArray[value]) ? this.autoSearchArray[value].filter(option => option.toLowerCase().includes(searchval.toLowerCase())) : []));
    }
  }

  notificationCount() {
    this.customGetApi(API_ENDPOINTS.NOTIFICATION_COUNT).subscribe((t: any) => {
      if (t.status) {
        this.notificationCnt = t.data;
      }
    });
  }
  
}

export class FilterObject {
  constructor(private _searchFilter: any = null, private _dataSource: any = null) {
    this.searchFilter = isNullOrUndefined(_searchFilter) ? new CommonFilter() : _searchFilter;
    this.dataSource = _dataSource;
  }
  searchFilter: CommonFilter;
  dataSource = [];

}

// let expenseName = '';
    // if (!isNullOrUndefined(expenseID) && expenseID > 0) {
    //   const list: any = this.getDropdownList(MastersEnum.Expense);
    //   if (!isNullOrUndefined(list) && list.value.length > 0) {
    //     list.value.filter((e) => {
    //       if (e.id == expenseID) {
    //         expenseName = e.name;
    //       }
    //     });
    //   }
    // }
    // return expenseName;
    // getDropdownList(ddlFor) {
  //   const obj = this.ddl[ddlFor];
  //   if (!isNullOrUndefined(obj)) {
  //     if (!isNullOrUndefined(obj.list) && obj.list.length > 0) {
  //       return Observable.of(obj.list);
  //     } else {
  //       return this.httpClient.get(obj.api).map((t: any) => {
  //         if (t.status === true) {
  //           this.ddl[ddlFor].list = t.data;
  //           return t.data;
  //         } else {
  //           return Observable.throw(t.message);
  //         }
  //       });
  //     }
  //   } else {
  //     Logger.Warn(`getDropdownList Not Exists ${ddlFor}`);
  //     return Observable.of(null);
  //   }
  // }

  // getDropdownName(id: number, pageNo: VendorEnum, matchkey = 'id', resultKey = 'name') {
  //   let name = '';
  //   if (!isNullOrUndefined(id) && id > 0) {
  //     const list: any = this.getDropdownList(pageNo);
  //     if (!isNullOrUndefined(list) && list.value.length > 0) {
  //       list.value.filter((e) => {
  //         if (e[matchkey] == id) {
  //           name = e[resultKey];
  //         }
  //       });
  //     }
  //   }
  //   return name;
  // }

  // save(master: any, param1: any = null, queryParam: any = null): Observable<ApiResponse> {
  //   return this.httpClient.post<ApiResponse>(this.masterUrl[master].Save, param1).map(t => t);
  // }

  // isExists(master: any, param1: any = null): Observable<ApiResponse> {
  //   return this.httpClient.get<ApiResponse>(this.masterUrl[master].isExists + param1);
  // }

  // byId(master: any, param1: any = null): Observable<any> {
  //   return this.httpClient.get<ApiResponse>(this.masterUrl[master].byId + param1).map(t => t);;
  // }

  // delete(master: any, param1: any = null, queryParam: any = null): Observable<any> {
  //   return this.httpClient.post<any>(this.masterUrl[master].Delete, param1).map(t => t);
  // }

  // deleteById(master: any, param1: any = null, queryParam: any = null): Observable<any> {
  //   return this.httpClient.get<any>(this.masterUrl[master].Delete + param1).map(t => t);
  // }
